var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": "sendButton",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M27.442 15.1275L6.32759 3.30346C6.14996 3.20399 5.9462 3.1611 5.74354 3.18053C5.54089 3.19996 5.34899 3.28078 5.1935 3.4122C5.03801 3.54361 4.92633 3.71935 4.87339 3.91593C4.82045 4.11252 4.82877 4.32057 4.89725 4.5123L8.87988 15.6637C8.95756 15.8812 8.95756 16.1189 8.87988 16.3363L4.89725 27.4877C4.82877 27.6794 4.82045 27.8875 4.87339 28.0841C4.92633 28.2807 5.03801 28.4564 5.1935 28.5878C5.34899 28.7192 5.54089 28.8001 5.74355 28.8195C5.9462 28.8389 6.14996 28.796 6.32759 28.6966L27.442 16.8725C27.597 16.7857 27.7262 16.659 27.8161 16.5057C27.906 16.3523 27.9533 16.1778 27.9533 16C27.9533 15.8222 27.906 15.6477 27.8161 15.4943C27.7262 15.341 27.597 15.2144 27.442 15.1275V15.1275Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M9 16H17",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }